import { fetchEndpointData } from '@utils/fetchEndpointData';

import type {
  CustomerPortalCreditNoteListItem,
  CustomerPortalCreditNoteResponse,
} from './endpoints/CustomerPortalCreditNotesEndpoint.types';

export interface CustomerPortalCreditNotesFilters {
  search?: string;
}

export async function fetchCustomerPortalCreditNotes(args: {
  customerId: number;
  cursor?: string;
  take?: number;
  filters?: CustomerPortalCreditNotesFilters;
}): Promise<CustomerPortalCreditNoteListItem[]> {
  const searchParams = new URLSearchParams();
  searchParams.append('customerId', args.customerId.toString());
  if (args.cursor != null) {
    searchParams.append('id', args.cursor);
  }
  if (args.take != null) {
    searchParams.append('take', args.take.toString());
  }
  if (args.filters?.search) {
    searchParams.append('search', args.filters.search);
  }

  return fetchEndpointData<CustomerPortalCreditNoteListItem[]>(
    `/api/customer-portal/credit-notes?${searchParams.toString()}`,
    { method: 'GET' },
  );
}

export async function fetchCustomerPortalCreditNote(id: string): Promise<CustomerPortalCreditNoteResponse> {
  return fetchEndpointData<CustomerPortalCreditNoteResponse>(`/api/customer-portal/credit-notes/${id}`, {
    method: 'GET',
  });
}
